import { GetLoadables } from './loader';
// #if process.env.UIX_CHUNKED === 'true'
let loader = ()=>{
    return import(/* webpackChunkName: 'tex' */ './loadTeX');
};
const T = GetLoadables(loader, [
    'TeX'
]);
// #endif
// #if process.env.UIX_CHUNKED === 'false'
// import * as T from './loadTeX'
// #endif
export let { TeX } = T;
